import React, { PropsWithChildren, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Note: It's essential to prefix the target id with **"wk-portal-target:"** to let pretty clear the target element is being used by a portal.
 *
 * And for the rest of the id name, the more specific the better, to avoid conflicts.
 **/

export function Portal({
  children,
  targetId,
  triggerRender,
}: PropsWithChildren<{
  targetId: `wk-portal-target:${string}`;
  triggerRender?: unknown;
}>) {
  const TARGET_ID_PREFIX = 'wk-portal-target:';

  const [targetElement, setTargetElement] = useState(getElementById(targetId));

  useEffect(() => {
    setTargetElement(getElementById(targetId));
  }, [targetId, triggerRender]);

  if (!targetId?.startsWith(TARGET_ID_PREFIX)) {
    console.error(
      `Portal Error: target id must starts with '${TARGET_ID_PREFIX}'`
    );

    return null;
  }

  return (
    <span className="wk-portal">
      {targetElement && createPortal(children, targetElement, targetId)}
    </span>
  );
}

function getElementById(id: string) {
  return document.getElementById(id);
}
